import React, { Component } from 'react';
import PropTypes from 'prop-types';
class UploadCsvPreview extends Component {
  static propTypes = {
    csvData: PropTypes.array.isRequired,
    csvHeader: PropTypes.array.isRequired,
    titleFieldMap: PropTypes.object.isRequired, 
  };

  render() {
    const { csvData, csvHeader, titleFieldMap } = this.props;
    return (
      <div className="row">
        <div className="col-md-12 text-center">
          <h2>Imported CSV Content</h2>
        </div>
        <div className="col-md-12 table-responsive csv-preview-table w-100vh show_scrollbar">
          <table className="table table-bordered table-hover table-sm table-word-break">
            <thead>
              <tr>
                {Object.keys(csvHeader).map((key, index) => (
                  <th key={key}>{csvHeader[index]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {csvData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {csvHeader.map((title, colIndex) => {
                    const fieldName = titleFieldMap[title];
                    return <td key={colIndex}>{row.data[fieldName] || ''}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UploadCsvPreview;
